

import { CheckboxVisibility, DefaultButton, DetailsList, Dropdown, IColumn, IconButton, IContextualMenuItem, IDetailsRowProps, Label, Persona, PersonaInitialsColor, PersonaPresence, PersonaSize, PrimaryButton, SearchBox, Stack, TextField } from '@fluentui/react';
import * as React from 'react'
import { useTranslation } from 'react-i18next';
import Paging from '../../control/paging'
import useToken from './login/useToken';
import * as Api from '../../api/src'
import { _renderRow } from '../../control/function/detailList'
import { API } from '@sentry/core';
import { LeftMenuContext } from '../../context/leftMenu.context';
import globalData from '../../common/globalData';
import { ToastAppType } from '../../common/constant/enum/toastAppType';
import { ToastAppMsgContext } from '../../context/toastApp.Context';
import moment from 'moment';
import { commonfn } from '../../common/commonfn';
import { useHistory } from 'react-router';
const UserApi = new Api.UserApi();
const ChangePassword = () => {
    const { userTokenInfo, token } = useToken();
    const { t } = useTranslation();
    const [currentPassWordErrorMessage, SetCurrentPassWordErrorMessage] = React.useState('');
    const [detail, SetDetail] = React.useState<Api.ChangePasswordRequest>({
        ConfirmPassword: "",
        NewPassword: "",
        CurrentPassword: "",
        Email: "",
    });
    const { setToastData } = React.useContext(ToastAppMsgContext);
    const [re_passwordErrorMessage, SetRepasswordErrorMessage] = React.useState('');
    const [passwordErrorMessage, SetPasswordErrorMessage] = React.useState('');
    let routerHistory = useHistory();
    React.useEffect(() => {
        SetPasswordErrorMessage("");
        SetRepasswordErrorMessage("");
        SetCurrentPassWordErrorMessage("");
    }, []);
    React.useEffect(() => {
        if (userTokenInfo) {
            SetDetail({ ...detail, Email: userTokenInfo["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"] })
        }
    }, [userTokenInfo]);
    const validateFormData = () => {
        let pass = true;
        if (!detail?.CurrentPassword) {
            SetCurrentPassWordErrorMessage(t("IsRequired").replace("{0}", t("CurrentPassword")));
            pass = false;
        }
        if (!detail?.NewPassword) {
            SetPasswordErrorMessage(t("IsRequired").replace("{0}", t("NewPassword")));
            pass = false;
        }

        if (!detail?.ConfirmPassword) {
            SetRepasswordErrorMessage(t("IsRequired").replace("{0}", t("RePassword")));
            pass = false;
        }
        if (detail?.NewPassword && detail?.ConfirmPassword && detail?.NewPassword != detail?.ConfirmPassword) {
            SetPasswordErrorMessage(t("PasswordAndConfirmPasswordNotMatch"));
            SetRepasswordErrorMessage(t("PasswordAndConfirmPasswordNotMatch"));
            pass = false;
        }
        if (detail?.NewPassword && detail.NewPassword.length < 6) {
            SetPasswordErrorMessage(t("PasswordMustBeAtLeast6Characters"));
            pass = false;
        }
        return pass;
    }
    const save = () => {
        if (!userTokenInfo || !validateFormData() || !detail) return;
        UserApi.apiUserChangePasswordPost(detail).then((res) => {
            if (!res || res.status != 200) return;
            if (res.data.Messages && res.data.Messages.length > 0 && res.data.Messages[0] == "PassWordIncorrect") {
                SetCurrentPassWordErrorMessage(t("CurrentPassWordIncorrect"));
                return;
            }
            setToastData({ Message: t("Successed"), Type: ToastAppType.Success });
        });
    }
    return (
        <>
            <div className={"page-header"}>
                <IconButton iconProps={{ iconName: "ChromeBack" }} onClick={() => {
                    routerHistory.push("/userprofile");
                }}
                ></IconButton>
                <Label>{t("UserProfile")}</Label>
            </div>
            <div className="page-content ms-Grid" dir="ltr">
                <div className={"ms-Grid-row flex-center"}>
                    <div className="ms-Grid-col ms-md3 margin-auto">
                        <TextField type="password" autoFocus={true} errorMessage={currentPassWordErrorMessage} label={t("CurrentPassword") + " (*)"} value={detail?.CurrentPassword || ""}
                            onChange={(e, newValue) => { SetDetail({ ...detail, CurrentPassword: (newValue || "") }); SetCurrentPassWordErrorMessage(""); }}></TextField>
                    </div>
                </div>
                <div className={"ms-Grid-row flex-center"}>
                    <div className="ms-Grid-col  ms-md3 margin-auto">
                        <TextField type="password" autoFocus={false} label={t("NewPassword") + " (*)"} errorMessage={passwordErrorMessage} value={detail?.NewPassword || ""}
                            onChange={(e, newValue) => {
                                SetDetail({ ...detail, NewPassword: (newValue || "").toString() });
                                SetPasswordErrorMessage("");
                            }} ></TextField>
                    </div>
                </div>
                <div className={"ms-Grid-row flex-center"}>
                    <div className="ms-Grid-col ms-md3 margin-auto">
                        <TextField type="password" autoFocus={false} label={t("RePassword") + " (*)"} value={detail?.ConfirmPassword || ""} errorMessage={re_passwordErrorMessage}
                            onChange={(e, newValue) => {
                                SetDetail({
                                    ...detail, ConfirmPassword: (newValue || "")
                                });
                                SetRepasswordErrorMessage("");
                            }}
                        ></TextField>
                    </div>
                </div>
                <div className={"ms-Grid-row flex-center"}>
                    <div className="ms-Grid-col ms-md3 margin-auto">
                        <div style={{ textAlign: 'right' }}>
                            <PrimaryButton onClick={() => { save() }}>{t("Save")}</PrimaryButton>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default ChangePassword;


